/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastDeductiblePaid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LastDeductiblePaid({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/LastDeductiblePaid"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredTxCategoryInsuredOrthoInsuredYearDeductiblePaidLastValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'tx_category_insured.ortho_insured.year_deductible_paid_last',
})
  return (<React.Fragment
>
<div
  data-testid="LastDeductiblePaid.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Latest deductible paid"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.tx_category_insured.ortho_insured.year_deductible_paid_last"
 text={insuredTxCategoryInsuredOrthoInsuredYearDeductiblePaidLastValueData}
/>
</div>
{children}
</React.Fragment>)
}